import infoIconUrl from '../images/icons/info.svg';
import infoTextIconUrl from '../images/icons/info-text.svg';
import inputIconUrl from '../images/icons/input.svg';
import outputIconUrl from '../images/icons/output.svg';
import conceptIconUrl from '../images/icons/concept.svg';
import returnedIconUrl from '../images/icons/returned.svg';
import lockedIconUrl from '../images/icons/locked.svg';
import editIconUrl from '../images/icons/edit.svg';
import playIconUrl from '../images/icons/play.svg';
import stopIconUrl from '../images/icons/stop.svg';
import logoutIconUrl from '../images/icons/logout.svg';
import bookHelpIconUrl from '../images/icons/book-help.svg';
import bookInfoIconUrl from '../images/icons/book-info.svg';
import collapsedOnIconUrl from '../images/icons/collapsed-on.svg';
import collapsedOffIconUrl from '../images/icons/collapsed-off.svg';
import lockIconUrl from '../images/icons/lock.svg';
import chipActiveIconUrl from '../images/icons/chip-active.svg';
import chipInactiveIconUrl from '../images/icons/chip-inactive.svg';
import documentIconUrl from '../images/icons/document.svg';
import documentDirIconUrl from '../images/icons/document-dir.svg';
import downloadIconUrl from '../images/icons/download.svg';
import dotOrangeIconUrl from '../images/icons/dot-orange.svg';
import copyIconUrl from '../images/icons/copy.svg';
import subprocesIconUrl from '../images/icons/subproces.svg';
import noSubprocesIconUrl from '../images/icons/no-subproces.svg';

export const icons: Record<string, IconDef> = {
    moreInfo: { icon: infoIconUrl },
    infoText: { icon: infoTextIconUrl },
    close: { text: '×' },
    add: { text: '+' },
    delete: { text: '✕' },
    arrowUp: { text: '▲' },
    arrowDown: { text: '▼' },
    warning: { text: '⚠' },
    // přepínač světlého/tmavého režimu (docs/tasks/design/plan-001.md, C3)
    colorModeDark: { text: '☾' },
    colorModeLight: { text: '☀' },
    input: { icon: inputIconUrl },
    output: { icon: outputIconUrl },
    concept: { icon: conceptIconUrl },
    returned: { icon: returnedIconUrl },
    locked: { icon: lockedIconUrl },
    edit: { icon: editIconUrl },
    play: { icon: playIconUrl },
    stop: { icon: stopIconUrl },
    logout: { icon: logoutIconUrl },
    bookHelp: { icon: bookHelpIconUrl },
    // docs/tasks/039.md część 2 — informační dokumenty (admin-edit i runtime view trigger).
    bookInfo: { icon: bookInfoIconUrl },
    // docs/tasks/025-history.md Część 2 — journal block (un)collapse toggle, and the lock shown
    // instead of a step link when the acting chair lacks ShowRunningStep.
    collapsedOn: { icon: collapsedOnIconUrl },
    collapsedOff: { icon: collapsedOffIconUrl },
    lock: { icon: lockIconUrl },
    // ERunningProcStepStatus icons — running reuses play (already the "in progress" visual), done
    // reuses locked's checkmark (a step goes Done exactly when every output is Locked, same idea),
    // wait reuses stop (nothing can proceed yet).
    wait: { icon: stopIconUrl },
    running: { icon: playIconUrl },
    done: { icon: lockedIconUrl },
    // docs/tasks/029-conditions.md Część 3 — whether a ProcStepScript is already attached to a step.
    chipActive: { icon: chipActiveIconUrl },
    chipInactive: { icon: chipInactiveIconUrl },
    // docs/tasks/034-zobrazeni-pdf.md — panel dokumentů, náhled/generování.
    document: { icon: documentIconUrl },
    // docs/tasks/040-params-files.md — attachment/multiAttachment param display + download link.
    attachment: { icon: documentDirIconUrl },
    download: { icon: downloadIconUrl },
    // docs/tasks/041.md — trvalá upload-progress flash: fronta/probíhá/hotovo.
    dotOrange: { icon: dotOrangeIconUrl },
    // docs/tasks/043.md — export šablony procesu jako JSON (kopírovat do schránky).
    copy: { icon: copyIconUrl },
    // docs/tasks/052-call-process-3.md — krok/proces spouští podproces / neexistuje jako podproces.
    subproces: { icon: subprocesIconUrl },
    noSubproces: { icon: noSubprocesIconUrl },
    // docs/tasks/037.md část 2c — FormHtmlareaToolbar.vue. Glyphy jsou zatím prosté UTF-8 znaky/
    // zkratky, ne obrázky ("Ikony prozatím UTF8 nebo textové znaky").
    bold: { text: 'B', cssClass: 'fw-bold' },
    italic: { text: 'I', cssClass: 'fst-italic' },
    underline: { text: 'U', cssClass: 'text-decoration-underline' },
    strike: { text: 'S', cssClass: 'text-decoration-line-through' },
    heading: { text: 'H' },
    heading1: { text: 'H1' },
    heading2: { text: 'H2' },
    heading3: { text: 'H3' },
    heading4: { text: 'H4' },
    heading5: { text: 'H5' },
    heading6: { text: 'H6' },
    blockquote: { text: '"' },
    list: { text: '•' },
    listDecimal: { text: '1.' },
    listAlpha: { text: 'a.' },
    listRoman: { text: 'i.' },
    horizontalRule: { text: 'HR' },
    table: { text: 'T' },
    fullscreen: { text: '⛶' },
    codeEditor: { text: '</>' },
    tableAddRowBefore: { text: 'R↑' },
    tableAddRowAfter: { text: 'R↓' },
    tableDeleteRow: { text: 'R✕' },
    tableAddColBefore: { text: 'C←' },
    tableAddColAfter: { text: 'C→' },
    tableDeleteCol: { text: 'C✕' },
    tableMergeCells: { text: 'M' },
    tableSplitCell: { text: 'Sp' },
    tableToggleHeaderRow: { text: 'Hdr' },
    alignLeft: { text: '⇤' },
    alignCenter: { text: '⇔' },
    alignRight: { text: '⇥' },
    alignJustify: { text: '≡' },
    cssClass: { text: '.cls' },
}

export type IconNames = keyof typeof icons;

export type IconDef = {
    text?: string, // Ikona pomocí běžného znaku
	icon?: string, // Ikona pomocí obrázku
	cssClass?: string, // Ikona pomocí css
}